<template>
  <div class="wrap">
    <!-- <van-nav-bar :title="$t('user.title')" :border="false" /> -->
    <div class="content">
      <div class="userInfo_bar">
        <!-- <VanImage width="50" height="50" :src="getImageUrl(userInfo.userimg)" round>
          <VanImage slot="error" width="50" height="50" :src="require('@/assets/Img/myImg/MyOne.png')" round />
        </VanImage> -->
        <!-- <div class="user_name">
          <span>{{ $t('newAdd.account') }}:</span> {{ userInfo.userphone }}
        </div> -->
        <div class="credit_score">
          <img src="@/assets/new/credit_score.png" alt="">
          <div class="credit">{{ userInfo.credit || 0 }}</div>
        </div>
        <div class="userphone">{{ userInfo.userphone }}</div>
      </div>
      <!-- <div class="btns">
        <div class="btn" @click="toRecharge">{{ $t('topUp') }}</div>
        <div class="btn" @click="toWithdraw">{{ $t('withdraw') }}</div>
      </div> -->
      <div class="items">
        <div class="btn_item" @click="handleTo('/repayDetail')">
          <img src="../../assets/new/user/repayment.png" alt="">
        </div>
        <div class="btn_item" @click="handleTo('/baseInfoDetail')">
          <img src="../../assets/new/user/information.png" alt="">
        </div>
        <div class="btn_item" @click="back">
          <img src="../../assets/new/user/back.png" alt="">
        </div>
      </div>
      <!-- <div class="home" @click="handleTo('/goods')">
        <img src="../../assets/new/user/home.png" alt="">
      </div> -->
    </div>
    <van-overlay :show="walletShow" z-index="10" class="wallet">
      <div class="wallet_cont" @click.stop>
        <van-field v-model="walletNum" required label-width="0" :placeholder="$t('user.inputAmount')" />
        <div class="btns">
          <div class="btn cancel" @click="walletShow = false">{{ $t('user.Button.One') }}</div>
          <div class="btn confirm" @click="walletConfirm">{{ $t('user.Button.Two') }}</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Dialog, NavBar, Image as VanImage, Icon, Overlay, Field } from "vant";
export default {
  data() {
    return {
      walletShow: false,
      walletNum: ''
    }
  },
  components: {
    [NavBar.name]: NavBar,
    [Dialog.Component.name]: Dialog.Component,
    VanImage,
    [Icon.name]: Icon,
    [Overlay.name]: Overlay,
    [Field.name]: Field
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    toRecharge() {
      this.$router.push("/new-recharge");
    },
    toWithdraw() {
      this.$router.push('/new-withdraw')
    },
    toService() {
      this.$api.toService();
    },
    handleTo(path) {
      this.$router.push(path)
    },
    walletClick() {
      this.walletShow = true;
    },
    walletConfirm() {
      console.log('walletConnfirm');
      this.walletShow = false;
    },
    logoutEvent() {
      let _this = this;
      Dialog.confirm({
        title: this.$t("user.quit"),
        message: this.$t("user.logoutEvent"),
        cancelButtonText: this.$t("user.Button.One"),
        confirmButtonText: this.$t("user.Button.Two"),
      }).then(() => {
        let pwdState = _this.$cookie.get("the-pwd-state");
        let pwdObj = _this.$cookie.get("the-pwd-obj");
        _this.$cookie.clear();
        _this.$cookie.set("the-pwd-state", pwdState);
        _this.$cookie.set("the-pwd-obj", pwdObj);
        _this.$router.push("/login");
      }).catch(() => { });
    },
    back(){
      this.$router.back();
    },

    getImageUrl(url) {
      const reg = new RegExp("http");
      if (reg.test(url)) return url;
      return this.verConfig.url + url;
    },
    checkLans(actions, index) {
      if (actions.value === getLanguage()) {
        this.switchLansShow = false;
        return;
      }
      setLanguage(actions.value);
      location.reload();
    },
  },
  created() {
  },
};
</script>

<style lang="less" scoped>
@Color: var(--theme);
@button-border-radius: 20px;
@background: var(--nav-background);
@bg: var(--bg);
@sizeColor: var(--sizeColor);

.flex(@JC: center; @FW: nowrap; @AI: center; @FD: row) {
  display: flex;
  flex-wrap: @FW;
  flex-direction: @FD;
  justify-content: @JC;
  align-items: @AI;
}

.text-overflow(@num: 1) {
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: @num;
}

.wrap {
  min-height: calc(100vh);
  background: @background;
  background: var(--userBg) no-repeat;
  background-size: cover;

  .content {
    padding: calc(15rem / 16);

    .userInfo_bar {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: calc(20rem / 16);
      // background: linear-gradient(180deg, #2752e7, #e43832);
      // background-size: 100% 100%;
      // color: var(--white);
      // border-radius: calc(10rem / 16);
      // padding-top: calc(30rem / 16);

      .user_name {
        padding: calc(5rem / 16) calc(15rem / 16);
        border-radius: calc(15rem / 16);
        font-size: calc(14rem / 16);
        background: var(--btnColor);
        color: var(--btnsizeColor);
        font-weight: bold;
        margin-bottom: calc(15rem / 16);

        span {
          text-transform: uppercase;
        }
      }

      .credit_score {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        color: var(--nav-background);
        margin-top: 30px;
        position: relative;

        img {
          // height: calc(54rem / 16);
          width: 230px;
          height: auto;
          display: block;
          margin-bottom: calc(10rem / 16);
        }

        .credit {
          font-size: calc(20rem / 16);
          margin-bottom: calc(5rem / 16);
          position: absolute;
          right: 0;
          left: 50%;
          bottom: 20px;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--black);
          font-weight: bold;
        }

        span {
          text-transform: uppercase;
          margin-bottom: calc(5rem / 16);
        }
      }
      .userphone{
        color: var(--black);
        // margin-top: -20px;
        font-size: 16px;
        font-weight: bold;
      }
    }

    .items {
      padding: 0 calc(15rem / 16);
      display: flex;
      align-items: center;
      gap: 30px;
      justify-content: center;

      .btn_item {
        width: calc((100% - 80rem / 16) / 3);

        img {
          width: 90px;
          height: auto;
          display: block;
        }
      }

      .red {
        background: #ec6d6d;
        color: var(--white);
        margin-top: calc(20rem / 16);
      }
    }

    .btns {
      display: flex;
      column-gap: calc(20rem / 16);

      .btn {
        flex: 1;
        height: calc(45rem / 16);
        margin-top: calc(20rem / 16);
        background: #f96;
        border-radius: calc(10rem / 16);
        color: var(--white);
        font-weight: 300;
        text-align: center;
        line-height: calc(45rem / 16);
      }
    }
  }

  .home {
    position: fixed;
    bottom: 120px;
    left: 50%;
    transform: translateX(-50%);

    img {
      width: 130px;
      height: auto;
      display: block;
    }
  }

  .wallet {
    display: flex;
    align-items: center;
    justify-content: center;

    .wallet_cont {
      min-width: 40%;
      background-color: var(--white);
      border-radius: calc(5rem / 16);
      overflow: hidden;
      padding: calc(10rem / 16);

      /deep/ .van-cell::after {
        transform: scaleY(.5);
        border-bottom: 1px solid #ebedf0;
      }

      .btns {
        padding: calc(15rem / 16) calc(15rem / 16) calc(5rem / 16);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .btn {
          background-color: #2969ff;
          color: var(--white);
          border-radius: calc(5rem / 16);
          font-size: calc(13rem / 16);
          padding: calc(5rem / 16) calc(10rem / 16);
        }
      }
    }
  }
}
</style>